import fetch from '../../common/services/api/fetch';

export default function addUserPreferenceRecentlySearchedItem(searchType, id) {
    return fetch(`/ui/users/preferences/recently_searched/add?type=${searchType}&id=${id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    });
}
